<template>
    <div v-if="language.includes('es')" class="container">
        <div class="text">   
            ¿Te gustó este relato?
            <div>
                <button @click="like" class="botonL">SI</button>
                <button @click="dislike" class="botonD">NO</button>
            </div>
        </div>
    </div>
    <div v-else class="container">
        <div class="text">   
            Did you like this folktale?
            <div>
                <button @click="like" class="botonL">YES</button>
                <button @click="dislike" class="botonD">NO</button>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data () {
        return {
            language: navigator.language
        }
    },
    methods: {
        like () {
            this.$emit('liked')
        },
        dislike () {
            this.$emit('disliked')
        }
    }
}
</script>


<style scoped lang="scss">
.container {
    // Parte externa del popup 
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 2;
    
    // Popup
    .text {
        border-radius: 30px;
        background-color: white;
        width: 70%;
        padding: 30px;
        font-size: 24pt;
        font-family: Cambay-Regular;
        color: #3B5CAB;   
        position: relative;
    }

    
    // Botones de like/dislike
    .botonL {
        background-color: green;
        color: #ffffff;
        font-family: Cambay-Regular;
        font-size: 24pt;
        padding-top: 5px;
        border: none;
        border-radius: 50%;
        align-items: center;
        cursor: pointer;
        height: 80px;
        width: 80px;
        margin-right: 10px;
    }
    .botonD {
        background-color: red;
        color: #ffffff;
        font-family: Cambay-Regular;
        font-size: 24pt;
        padding-top: 5px;
        border: none;
        border-radius: 50%;
        align-items: center;
        cursor: pointer;
        height: 80px;
        width: 80px;
        margin-right: 10px;
    }
    .botonD:hover, .botonL:hover {
        background-color: #3B5CAB;
    }
}

// Resoluciones menores a 1000px
@media (max-width: 1000px) {
    .popup {
        .popup-inner {
            width: 90%;
            font-size: 18pt;
        }
    }
}
</style>
